const PdfIconButton = ({
  color = "#db0b27",
  width = 18,
  height = 18,
  strokeWidth = 1.25,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Icono PDF"
    {...props}
  >
    <path
      d="M4.83325 14V11.9166M4.83325 11.9166V10.6666C4.83325 10.2741 4.83325 10.0775 4.96159 9.95498C5.08992 9.83331 5.29575 9.83331 5.70825 9.83331H6.29159C6.89575 9.83331 7.38575 10.3 7.38575 10.875C7.38575 11.45 6.89575 11.9166 6.29159 11.9166H4.83325ZM16.4999 9.83331H15.4066C14.7191 9.83331 14.3749 9.83331 14.1616 10.0366C13.9483 10.24 13.9483 10.5675 13.9483 11.2225V11.9166M13.9483 11.9166V14M13.9483 11.9166H15.7708M12.1249 11.9166C12.1249 13.0666 11.1458 14 9.93742 14C9.66492 14 9.52909 14 9.42659 13.9441C9.18409 13.8108 9.20825 13.54 9.20825 13.3058V10.5275C9.20825 10.2933 9.18325 10.0225 9.42659 9.88915C9.52825 9.83331 9.66492 9.83331 9.93742 9.83331C11.1458 9.83331 12.1249 10.7666 12.1249 11.9166Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5 17.3333H7.93917C5.2225 17.3333 3.8625 17.3333 2.91917 16.6683C2.65071 16.4801 2.41075 16.2541 2.20667 15.9975C1.5 15.1092 1.5 13.8308 1.5 11.2725V9.15166C1.5 6.68249 1.5 5.44749 1.89083 4.46166C2.51917 2.87582 3.8475 1.62582 5.5325 1.03416C6.57917 0.666656 7.89 0.666656 10.515 0.666656C12.0133 0.666656 12.7633 0.666657 13.3617 0.876657C14.3242 1.21499 15.0833 1.92916 15.4425 2.83499C15.6667 3.39832 15.6667 4.10416 15.6667 5.51499V7.33332"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 8.99999C1.5 8.26335 1.79263 7.55688 2.31351 7.036C2.83439 6.51512 3.54086 6.22249 4.2775 6.22249C4.8325 6.22249 5.48667 6.31916 6.02583 6.17499C6.26142 6.11159 6.47621 5.98737 6.64865 5.81478C6.82109 5.64219 6.94513 5.4273 7.00833 5.19166C7.1525 4.65249 7.05583 3.99832 7.05583 3.44332C7.05605 2.70683 7.34878 2.00057 7.86964 1.47987C8.3905 0.959171 9.09684 0.666656 9.83333 0.666656"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PdfIconButton;
